import { render } from "./footer.vue?vue&type=template&id=0ea6965a"
const script = {}

import exportComponent from "/home/B2BServer/b2bPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__